
export const metaConstants = {
    GET_FB_PHOTOS_REQUEST: 'GET_FB_PHOTOS_REQUEST',
    GET_FB_PHOTOS_SUCCESS: 'GET_FB_PHOTOS_SUCCESS',
    GET_FB_PHOTOS_FAILURE: 'GET_FB_PHOTOS_FAILURE',

    GET_FB_VIDEOS_REQUEST: 'GET_FB_VIDEOS_REQUEST',
    GET_FB_VIDEOS_SUCCESS: 'GET_FB_VIDEOS_SUCCESS',
    GET_FB_VIDEOS_FAILURE: 'GET_FB_VIDEOS_FAILURE',
}